/* eslint-disable max-len */
export const CRBMonitorLogo = () => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 142 20"
    width="142"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <linearGradient id="a">
      <stop offset="0" stopColor="#21c4d5" />
      <stop offset="1" stopColor="#0f7f87" />
    </linearGradient>
    <linearGradient
      id="b"
      gradientUnits="userSpaceOnUse"
      x1="29.6964"
      x2="138.843"
      xlinkHref="#a"
      y1="8.81143"
      y2="28.883"
    />
    <linearGradient
      id="c"
      gradientUnits="userSpaceOnUse"
      x1="30.0138"
      x2="139.161"
      xlinkHref="#a"
      y1="7.06916"
      y2="27.1407"
    />
    <linearGradient
      id="d"
      gradientUnits="userSpaceOnUse"
      x1="30.4054"
      x2="139.549"
      xlinkHref="#a"
      y1="4.95654"
      y2="25.0281"
    />
    <linearGradient
      id="e"
      gradientUnits="userSpaceOnUse"
      x1="34.7117"
      x2="143.859"
      xlinkHref="#a"
      y1="1.9869"
      y2="22.062"
    />
    <linearGradient
      id="f"
      gradientUnits="userSpaceOnUse"
      x1="34.7363"
      x2="143.883"
      xlinkHref="#a"
      y1="1.87051"
      y2="21.9456"
    />
    <linearGradient
      id="g"
      gradientUnits="userSpaceOnUse"
      x1="35.0678"
      x2="144.215"
      xlinkHref="#a"
      y1=".054149"
      y2="20.1257"
    />
    <linearGradient
      id="h"
      gradientUnits="userSpaceOnUse"
      x1="35.8051"
      x2="144.952"
      xlinkHref="#a"
      y1="-3.95594"
      y2="16.1156"
    />
    <linearGradient
      id="i"
      gradientUnits="userSpaceOnUse"
      x1="35.8686"
      x2="145.016"
      xlinkHref="#a"
      y1="-4.28394"
      y2="15.7877"
    />
    <linearGradient
      id="j"
      gradientUnits="userSpaceOnUse"
      x1="35.9037"
      x2="145.051"
      xlinkHref="#a"
      y1="-4.47791"
      y2="15.5972"
    />
    <linearGradient
      id="k"
      gradientUnits="userSpaceOnUse"
      x1="36.2319"
      x2="145.379"
      xlinkHref="#a"
      y1="-6.27663"
      y2="13.7949"
    />
    <linearGradient
      id="l"
      gradientUnits="userSpaceOnUse"
      x1="2.90605"
      x2="25.4888"
      xlinkHref="#a"
      y1="-3.53271"
      y2="12.7757"
    />
    <linearGradient
      id="m"
      gradientUnits="userSpaceOnUse"
      x1="1.02978"
      x2="23.609"
      xlinkHref="#a"
      y1="-.933381"
      y2="15.375"
    />
    <linearGradient
      id="n"
      gradientUnits="userSpaceOnUse"
      x1="-2.86737"
      x2="19.7154"
      xlinkHref="#a"
      y1="4.45924"
      y2="20.7676"
    />
    <linearGradient
      id="o"
      gradientUnits="userSpaceOnUse"
      x1="-5.73478"
      x2="16.848"
      xlinkHref="#a"
      y1="8.43051"
      y2="24.7389"
    />
    <linearGradient
      id="p"
      gradientUnits="userSpaceOnUse"
      x1=".38437"
      x2="22.9636"
      xlinkHref="#a"
      y1="-.041078"
      y2="16.2708"
    />
    <linearGradient
      id="q"
      gradientUnits="userSpaceOnUse"
      x1="-2.09502"
      x2="20.4877"
      xlinkHref="#a"
      y1="3.3906"
      y2="19.7025"
    />
    <linearGradient
      id="r"
      gradientUnits="userSpaceOnUse"
      x1="-6.23913"
      x2="16.3436"
      xlinkHref="#a"
      y1="9.12885"
      y2="25.4372"
    />
    <linearGradient
      id="s"
      gradientUnits="userSpaceOnUse"
      x1="-4.17244"
      x2="18.4103"
      xlinkHref="#a"
      y1="6.26502"
      y2="22.5734"
    />
    <linearGradient
      id="t"
      gradientUnits="userSpaceOnUse"
      x1="2.74393"
      x2="25.3267"
      xlinkHref="#a"
      y1="-3.30698"
      y2="13.0014"
    />
    <linearGradient
      id="u"
      gradientUnits="userSpaceOnUse"
      x1="-5.15287"
      x2="17.4263"
      xlinkHref="#a"
      y1="7.62639"
      y2="23.9348"
    />
    <clipPath id="v">
      <path d="m0 0h142v20h-142z" />
    </clipPath>
    <g clipPath="url(#v)">
      <path
        d="m40.3794 13.6644 1.7634 1.7635c-.7497.8472-1.6735 1.5225-2.7083 1.9797-1.0349.4571-2.1562.6853-3.2874.669-4.4968 0-7.9003-3.4493-7.9003-8.0554 0-4.60617 3.4035-8.05548 7.9003-8.05548 1.0775-.01194 2.1458.19937 3.1377.62063.9918.42125 1.8856 1.04333 2.6252 1.82704l-1.8022 1.76345c-.5053-.54473-1.1183-.97842-1.8001-1.2735-.6819-.29509-1.4177-.44512-2.1606-.44058-3.0719 0-5.1846 2.56053-5.1846 5.56194 0 3.0014 2.1162 5.5619 5.1846 5.5619.8025.005 1.5966-.1643 2.3273-.4961.7307-.3319 1.3807-.8184 1.905-1.4261z"
        fill="url(#b)"
      />
      <path
        d="m43.0916 2.21262h5.121c3.0931 0 5.1634 2.00327 5.1634 4.84948 0 2.33834-1.245 4.1159-3.4705 4.6731l3.8796 6.0522h-3.1037l-3.6926-5.8864h-1.2239v5.8864h-2.6698zm7.5652 4.84948c0-1.5342-1.0581-2.31364-2.7828-2.31364h-2.1161v4.62729h2.1161c1.7176 0 2.7863-.77945 2.7863-2.31365z"
        fill="url(#c)"
      />
      <path
        d="m54.9526 2.21262h5.0506c2.5358 0 4.9623 1.17798 4.9623 4.45094.0154.5811-.1278 1.15542-.4143 1.66124-.2864.50582-.7053.92402-1.2116 1.20966.2222.04585 2.4265.84644 2.4265 3.65034 0 2.7369-2.2713 4.6061-5.2057 4.6061h-5.6078zm4.9624 6.34841c1.4919 0 2.3383-.55725 2.3383-1.9151 0-1.35786-1.0228-1.91511-2.3383-1.91511h-2.2925v3.84432zm3.1389 4.60617c0-1.4672-1.1145-2.0703-2.5817-2.0703h-2.8497v4.1547h2.8497c1.4672 0 2.5817-.5996 2.5817-2.0703z"
        fill="url(#d)"
      />
      <path
        d="m73.2008 2.21262 5.0752 7.83328 5.0717-7.83328h2.4688v15.57478h-2.6699v-10.47136l-4.8706 7.40646-4.8742-7.40646v10.47136h-2.6699v-15.57478z"
        fill="url(#e)"
      />
      <path
        d="m98.2346 12.5147c.0203 1.1202-.2933 2.2211-.9009 3.1625-.6076.9413-1.4816 1.6805-2.5108 2.1233-1.0292.4429-2.1669.5693-3.2682.3633-1.1013-.2061-2.1163-.7353-2.9158-1.5203-.7994-.7849-1.3471-1.7901-1.5733-2.8875-.2261-1.0973-.1205-2.2371.3034-3.2742.424-1.03714 1.147-1.92457 2.0771-2.54928.9301-.6247 2.0251-.9584 3.1455-.95859.7359-.01263 1.467.1213 2.1507.394.6836.2727 1.3062.67871 1.8314 1.19439s.9425 1.13071 1.2277 1.80928c.2851.6785.4324 1.4071.4332 2.1431zm-2.7157 0c0-1.6471-1.1145-3.04725-2.9167-3.04725-1.8023 0-2.9168 1.41075-2.9168 3.04725s1.1145 3.0472 2.9168 3.0472c1.8022 0 2.9167-1.4001 2.9167-3.0472z"
        fill="url(#f)"
      />
      <path
        d="m108.604 10.9558v6.8316h-2.67v-6.1615c0-1.513-.935-2.15846-2.092-2.15846-1.379 0-2.091 1.35786-2.091 1.35786v6.9621h-2.6699v-10.54543h2.4939v1.5342c.324-.5528.788-1.01044 1.345-1.32684.557-.31639 1.188-.48036 1.829-.4754 2.028-.01059 3.855 1.44602 3.855 3.98187z"
        fill="url(#g)"
      />
      <path
        d="m111.916 2.07858c.348 0 .689.10343.979.2972s.516.46918.65.79141c.133.32223.168.6768.1 1.01887-.068.34208-.236.6563-.483.90292-.246.24662-.56.41457-.902.48262-.343.06804-.697.03312-1.019-.10035-.323-.13347-.598-.3595-.792-.6495-.193-.29-.297-.63094-.297-.97972 0-.46769.186-.91623.517-1.24694.33-.33072.779-.51651 1.247-.51651zm-1.337 5.16338h2.67v10.54544h-2.67z"
        fill="url(#h)"
      />
      <path
        d="m114.388 7.24197h2.07v-3.13894h2.67v3.13894h3.174v2.40182h-3.174v4.24991c0 1.2908.667 1.6682 1.379 1.6682.4-.0179.786-.1487 1.115-.3774l.98 2.1797c-.763.4664-1.641.7107-2.536.7053-2.045 0-3.604-1.4918-3.604-3.7385v-4.68721h-2.071z"
        fill="url(#i)"
      />
      <path
        d="m133.923 12.5147c.021 1.1202-.293 2.2211-.901 3.1625-.607.9413-1.481 1.6805-2.51 2.1233-1.03.4429-2.167.5693-3.269.3633-1.101-.2061-2.116-.7353-2.915-1.5203-.8-.7849-1.347-1.7901-1.574-2.8875-.226-1.0973-.12-2.2371.304-3.2742.424-1.03714 1.147-1.92457 2.077-2.54928.93-.6247 2.025-.9584 3.145-.95859.736-.01263 1.467.1213 2.151.394s1.306.67871 1.831 1.19439c.526.51568.943 1.13071 1.228 1.80928.285.6785.433 1.4071.433 2.1431zm-2.715 0c0-1.6471-1.115-3.04725-2.917-3.04725s-2.917 1.41075-2.917 3.04725 1.115 3.0472 2.917 3.0472 2.91-1.4001 2.91-3.0472z"
        fill="url(#j)"
      />
      <path
        d="m142 7.31604-.924 2.39476c-.401-.17037-.834-.25333-1.27-.24335-.481.0114-.952.14734-1.365.39457-.414.24718-.756.59728-.994 1.01618v6.9092h-2.67v-10.54543h2.536v1.5342s.903-1.81282 2.864-1.81282c.622.01771 1.238.13683 1.823.35269z"
        fill="url(#k)"
      />
      <path
        d="m12.7144.262238v11.758662l8.8525-10.54894c-2.8844-.792808-5.8612-1.199597-8.8525-1.209722z"
        fill="url(#l)"
      />
      <path d="m10.831.262238c-2.98846.039955-5.96105.442617-8.85248 1.199142l8.85248 10.54892z" fill="url(#m)" />
      <path
        d="m.782972 2.97089c-.43671 2.08132-.6845996 4.19782-.7406492 6.32373h-.0423228v1.35788l9.32512 2.497z"
        fill="url(#n)"
      />
      <path d="m.151611 12.6416c.10468 1.3876.297877 2.7671.578412 4.13l7.406487-1.9856z" fill="url(#o)" />
      <path d="m15.416 14.7825 7.4065 1.9856c.2887-1.3627.4925-2.742.6102-4.13z" fill="url(#p)" />
      <path
        d="m14.6013 16.5142 2.4336 2.9026c1.5678-.1971 3.1198-.5035 4.6449-.917.0423 0 .0776-.0388.1199-.0564z"
        fill="url(#q)"
      />
      <path
        d="m8.94064 16.5177-7.21603 1.9327c.04493.018.09085.0333.13755.0459 1.51631.4316 3.06318.7476 4.62729.9452z"
        fill="url(#r)"
      />
      <path d="m12.7144 17.1913v2.5359c.6936-.0141 1.3766-.0447 2.0491-.0917z" fill="url(#s)" />
      <path
        d="m23.5456 10v-.70537h-.0423c-.0563-2.12472-.3042-4.24003-.7407-6.3202l-8.5421 10.18217 9.3251-2.4971c-.0218-.2193-.0218-.4402 0-.6595z"
        fill="url(#t)"
      />
      <path d="m10.831 19.7378v-2.5465l-2.07026 2.4689c.68187.0423 1.37196.0682 2.07026.0776z" fill="url(#u)" />
    </g>
  </svg>
)
